export default {
    items: {
        data: []
    },

    list_group: [],
    list_companies: []
}